"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTable = void 0;
/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const object_hash_1 = __importDefault(require("object-hash"));
const ngx_datatable_1 = require("@siemens/ngx-datatable");
const config_service_1 = require("../../../shared/config/config.service");
const web_socket_service_1 = require("../../../shared/connections/web-socket.service");
const users_service_1 = require("../../../shared/users/users.service");
const enums_1 = require("../@shared-types/vehicle/enums");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const vehicle_export_service_1 = __importDefault(require("../shared/services/export/vehicle-export.service"));
const filtering_1 = require("../shared/services/filtering");
const log_1 = __importDefault(require("../shared/services/log"));
const object_1 = __importDefault(require("../shared/services/object"));
const table_component_1 = require("../table-component/table.component");
const interface_service_1 = require("../../../shared/interface/interface.service");
const permissions_service_1 = require("../../../components/authorization/permissions.service");
const user_1 = require("../@types/user");
const customer_1 = require("../shared/models/customer/customer");
let VehicleTable = class VehicleTable extends table_component_1.GenericTableComponent {
    constructor(objectService, filteringService, permissionService, vehicle, configService, socketService, location, logService, usersService, vehicleExportService, interfaceService, customerModel) {
        super(filteringService, objectService, 'vehicleTable');
        this.vehicle = vehicle;
        this.configService = configService;
        this.socketService = socketService;
        this.location = location;
        this.logService = logService;
        this.usersService = usersService;
        this.vehicleExportService = vehicleExportService;
        this.interfaceService = interfaceService;
        this.customerModel = customerModel;
        this.filters = {};
        this.ColumnMode = ngx_datatable_1.ColumnMode;
        this.SortType = ngx_datatable_1.SortType;
        this.detailVehicle = null;
        this.detailHash = '';
        this.newVehicles = true;
        this.dummyVehicle = false;
        this.dataReady = false;
        this.importantComments = null;
        /** `permission` attribute directive is not usable in Angular
         * components. As as temp workaround we use this to toggle UI elements. */
        this.sellerPermission = false;
        this.initTable = (sold) => __awaiter(this, void 0, void 0, function* () {
            /** Table is called with a `DummyVehicle`, meaning it is only called
             * to directly go to a `DummyVehicle`'s form eg. for generating an offer.
             * We therefore only need to retreive the `DummyVehicle` for handing it
             * over to the form and not all vehicles in the table. */
            if (this.location.path().includes('dummy')) {
                this.dummyVehicle = true;
                /** Get `DummyVehicle` */
                const selectedId = this.interfaceService.getRouteParams().id;
                const vehicle = yield this.vehicle.getDummyVehicle(selectedId);
                this.tableData = [vehicle];
                this.filteredData = [vehicle];
                if (vehicle)
                    this.selectRow({ selected: [vehicle] });
                this.dataReady = true;
                return;
            }
            this.newVehicles = !sold;
            if (this.location.path().includes('sold')) {
                this.newVehicles = false;
            }
            this.dataReady = false;
            const filter = {
                'vehicleData.inventory.state': {
                    // eslint-disable-next-line max-len
                    $in: this.newVehicles ? [enums_1.EInventoryState.Ordered, enums_1.EInventoryState.Stock] : [enums_1.EInventoryState.Sold],
                },
            };
            this.vehicle.getAll(filter)
                .then((vehicles) => {
                this.tableData = vehicles;
                this.filteredData = vehicles;
                this.getDynamicFilerValues();
                if (this.interfaceService.getRouteParams().id) {
                    const selectedId = this.interfaceService.getRouteParams().id;
                    const vehicle = this.tableData.find((c) => String(c._id) === selectedId);
                    if (vehicle)
                        this.selectRow({ selected: [vehicle] });
                }
                this.dataReady = true;
                this.filterTable();
            })
                .catch((e) => this.logService.error(e));
        });
        /** Gets called from Rail Component when user switches
         * selection, but also on init. */
        this.switchSoldVehicles = (selectedItem) => {
            this.initTable(selectedItem === 'Ausgeliefert');
        };
        this.selectRow = (event) => {
            const params = this.interfaceService.getRouteParams();
            const vehicleId = String(event.selected[0]._id);
            if (this.dummyVehicle) {
                this.interfaceService.navigateToUrl('/vehicles/dummy', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            else if (this.newVehicles) {
                this.interfaceService.navigateToUrl('/vehicles/stock', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            else {
                this.interfaceService.navigateToUrl('/vehicles/sold', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            this.detailVehicle = this.tableData.find((v) => v._id === event.selected[0]._id) || null;
            this.detailHash = (0, object_hash_1.default)(this.detailVehicle);
        };
        this.hideDetailedVehicle = () => {
            if (this.newVehicles) {
                this.location.go('/vehicles/stock');
            }
            else {
                this.location.go('/vehicles/sold');
            }
            this.detailVehicle = null;
        };
        this.onPopState = () => {
            if (this.detailVehicle)
                this.hideDetailedVehicle();
        };
        this.downloadCsv = () => {
            this.vehicleExportService.exportCsv(this.filteredData, 'autoboard-fahrzeuge.csv');
        };
        this.showImportantComments = (vehicleId) => {
            this.importantComments = vehicleId;
        };
        this.hideImportantComments = () => {
            this.importantComments = null;
        };
        /** Some select filters will be populated with values from the dataset */
        this.getDynamicFilerValues = () => {
            this.filters.productionState.translations = {};
            [
                ...new Map(this.tableData.map((item) => [
                    item.vehicleData.production.productionState, item,
                ])).values(),
            ]
                .forEach((v) => {
                this.filters.productionState.translations[v.vehicleData.production.productionState || ''] = v.vehicleData.production.productionStateDescription || '';
            });
            // this.filters.seriesOptions.translations = {};
            // this.tableData.forEach((v) => {
            //   if (!v.vehicleData.features.seriesOptions?.length) return;
            //   v.vehicleData.features.seriesOptions.forEach((option) => {
            //     if (this.filters.seriesOptions.translations[option.code]) return;
            //     this.filters
            // .seriesOptions.translations[String(option.code)] = `${option.code} – ${option.description}`;
            //   });
            // });
        };
        this.getTableData = () => __awaiter(this, void 0, void 0, function* () { });
        this.socketService.on('sales_updateVehicleData', (payload) => {
            const parsed = JSON.parse(payload);
            let vehicleToUpdate = this.tableData.find((v) => v._id.toString() === parsed.vehicleId);
            if (!vehicleToUpdate)
                return;
            const merged = this.objectService
                .mergeObjects(vehicleToUpdate, parsed.data);
            vehicleToUpdate = merged;
            if (this.detailVehicle && String(this.detailVehicle._id) === parsed.vehicleId) {
                this.detailHash = (0, object_hash_1.default)(merged);
            }
        });
        if (permissionService.isPermitted([user_1.UserRole.ADMIN, user_1.UserRole.SELLER_PLUS])) {
            this.sellerPermission = true;
        }
        this.filters = {
            seriesOptions: {
                traversal: 'vehicleData.features.seriesOptions',
                type: 'ARRAY_OBJECT',
                objectKey: 'code',
            },
            additionalOptions: {
                traversal: 'vehicleData.features.additionalOptions',
                type: 'ARRAY_OBJECT',
                objectKey: 'code',
            },
            make: {
                traversal: 'modelData.make',
            },
            model: {
                traversal: 'modelData.model',
            },
            vin: {
                traversal: ['vin', '_id'],
            },
            modelDescription: {
                traversal: 'modelData.modelDescription',
            },
            state: {
                traversal: 'vehicleData.availability.state',
                translations: this.configService.get('sales_car_types'),
            },
            location: {
                traversal: 'vehicleData.inventory.location',
                translations: this.configService.get('general_locations'),
            },
            transmission: {
                traversal: 'modelData.engine.transmission.type',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.TRANSMISSION_TYPES),
            },
            drivetrain: {
                traversal: 'modelData.engine.drivetrain',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.DRIVETRAIN_TYPES),
            },
            fuel: {
                traversal: 'modelData.engine.fuel.type',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.FUEL_TYPES),
            },
            customer: {
                traversal: ['vehicleData.availability.sellData.customerId', 'vehicleData.availability.reservationData.customerId'],
                translationFunction: (filterValue) => this.customerModel.getName(filterValue),
            },
            customerLegacy: {
                traversal: ['vehicleData.availability.sellData.customer', 'vehicleData.availability.reservationData.customer'],
            },
            seller: {
                traversal: ['vehicleData.availability.sellData.seller', 'vehicleData.availability.reservationData.seller'],
                translations: this.usersService.getUsersForFilter(),
            },
            bodycode: {
                traversal: 'bodycode',
            },
            orderNumber: {
                traversal: 'vehicleData.order.orderNumber',
            },
            availability: {
                traversal: 'vehicleData.availability.code',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.AVAILABILITY),
            },
            license: {
                traversal: 'vehicleData.registration.licence',
            },
            modelyear: {
                traversal: 'modelData.modelyear',
            },
            inventory: {
                traversal: 'vehicleData.inventory.state',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.INVENTORY_STATE),
            },
            colorOuter: {
                traversal: ['vehicleData.features.exteriorColor.manufacturerCode', 'vehicleData.features.exteriorColor.manufacturerName'],
            },
            colorOuterSelection: {
                translations: this.configService.getConstant(config_service_1.ConstantTypes.EXTERIOR_COLOR_NAME),
                traversal: 'vehicleData.features.exteriorColor.color',
            },
            colorInner: {
                traversal: ['vehicleData.features.interiorColor.manufacturerCode', 'vehicleData.features.interiorColor.manufacturerName'],
            },
            colorInnerSelection: {
                traversal: 'vehicleData.features.interiorColor.color',
                translations: this.configService.getConstant(config_service_1.ConstantTypes.INTERIOR_COLOR_NAME),
            },
            mobile: {
                traversal: 'apiData.MOBILE_SELLER',
                translations: { NOT_DEFINED: 'Nicht auf mobile.de', DEFINED: 'Auf mobile.de' },
            },
            dataCheck: {
                traversal: 'dataCheck',
                translations: { NOT_DEFINED: 'Hat kein Datencheck', DEFINED: 'Hat Datencheck' },
            },
            pkwEnvkReady: {
                traversal: 'pkwEnvkReady',
                translations: { NOT_DEFINED: 'Pkw-EnVKV unzulässig', DEFINED: 'Pkw-EnVKV konform' },
            },
            infotainment: {
                traversal: 'modelData.infotainment',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    androidAuto: 'Android Auto',
                    appleCarplay: 'Apple CarPlay',
                    betterSound: 'Besseres Soundsystem',
                    bluetooth: 'Bluetooth',
                    boardComputer: 'Boardcomputer',
                    cd: 'CD',
                    digitalDashboard: 'Digitaler Tachograph',
                    handsFreePhoneSystem: 'Freisprecheinrichtung',
                    wirelessCharging: 'Kabelloses Laden für Smartphones',
                    multifunctionSteeringWheel: 'Multifuntionslenkrad',
                    musicStreaming: 'Musikstreamingdienste',
                    satNav: 'Navigationssystem',
                    voiceControl: 'Sprachassistent',
                    touchscreen: 'Touchscreen',
                    tv: 'TV',
                    usb: 'USB',
                    wifi: 'Wi-Fi',
                },
            },
            assistance: {
                traversal: 'modelData.assistance',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    lightSensor: 'Automatisches Abblendlicht',
                    hillAssist: 'Berganfahrassistent',
                    automaticHighBeam: 'Fernlichtassistent',
                    speedLimiter: 'Geschwindigkeitslimit-Assistent',
                    emergencyCall: 'Notrufsystem',
                    rainSensor: 'Regensensor',
                    tirePressureMonitoring: 'Reifendruckkontrollsystem',
                    powerSteeting: 'Servolenkung',
                    laneAssistance: 'Spurhalteassistent',
                    startStop: 'Start-Stopp-System',
                    blindSpot: 'Totwinkel-Assistent',
                    signRecognition: 'Verkehrszeichenerkennung',
                },
            },
            comfort: {
                traversal: 'modelData.comfort',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    ambientLighting: 'Ambientebeleuchtung',
                    armRest: 'Armlehne',
                    heatedSteeringWheel: 'Beheizbares Lenkrad',
                    heatedRearSeats: 'Beheizbare Rücksitze',
                    heatedFrontSeats: 'Beheizbare Vordersitze',
                    heatedWindshield: 'Beheizbare Windschutzscheibe',
                    electricSideMirrors: 'Elektrische Außenspiegel',
                    electricWindows: 'Elektrische Fensterheber',
                    electricTailgate: 'Elektrische Heckklappe',
                    electricRearSeats: 'Elektrisch verstellbare Rücksitze',
                    electricFrontSeats: 'Elektrisch verstellbare Vordersitze',
                    bootDivider: 'Gepäckraumabtrennung',
                    headUpDisplay: 'Head-up-Display',
                    keylessEntry: 'Keyless-Entry',
                    leatherSteeringWheel: 'Lederlenkrad',
                    lumbarSupport: 'Lendenwirbelstütze',
                    airSuspension: 'Luftfahrwerk',
                    massageSeats: 'Massagesitze',
                    panoramicRoof: 'Panoramadach',
                    sunroof: 'Schiebedach',
                    ventilatedFrontSeats: 'Sitzlüftung',
                    foldPassengerSeat: 'Umklappbarer Beifahrersitz',
                    centralLocking: 'Zentralverriegelung',
                },
            },
            general: {
                traversal: 'modelData.features',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    allowWheels: 'Alufelgen',
                    roofRails: 'Dachreling',
                    auxHeating: 'Standheizung',
                    summerTires: 'Sommerreifen',
                    winterTires: 'Winterreifen',
                    allSeasonTires: 'Ganzjahresreifen',
                    steelWheels: 'Stahlfelgen',
                    skibag: 'Skitasche',
                },
            },
            safety: {
                traversal: 'modelData.safety',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    headlightWasher: 'Scheinwerferreinigungsanlage',
                    abs: 'ABS',
                    esp: 'ESP',
                    alarm: 'Alarmanlage',
                    distanceWarning: 'Auffahrwarnsystem',
                    fatigueWarning: 'Aufmerksamkeits-Assistent',
                    dimmingMirror: 'Automatisch abblendende Spiegel',
                    glareFreeHighBeam: 'Blendfreies Fernlicht',
                    immobilizer: 'Elektronische Wegfahrsperre',
                    isofixPassenger: 'Isofix-Halterungen Beifahrersitz',
                    isofixBack: 'Isofix-Halterungen Rücksitze',
                    nightVision: 'Nachtsicht-Assistent',
                    frontFogLights: 'Nebelscheinwerfer',
                    collisionAvoidance: 'Notbremsassistent',
                },
            },
            sport: {
                traversal: 'modelData.sport',
                type: 'BOOLEAN_OBJECT',
                translations: {
                    performanceHandling: 'Sportfahrwerk',
                    seats: 'Sportsitze',
                    paddleShifters: 'Schaltwippen',
                },
            },
            productionState: {
                traversal: 'vehicleData.production.productionState',
                translations: {},
            },
        };
        this.loadFiltersFromStorage();
    }
};
__decorate([
    (0, core_1.HostListener)('window:popstate', ['$event']),
    __metadata("design:type", Object)
], VehicleTable.prototype, "onPopState", void 0);
VehicleTable = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-table',
        templateUrl: require('./vehicle-table.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _a : Object, typeof (_b = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _b : Object, typeof (_c = typeof permissions_service_1.PermissionsService !== "undefined" && permissions_service_1.PermissionsService) === "function" ? _c : Object, typeof (_d = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _d : Object, typeof (_e = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _e : Object, typeof (_f = typeof web_socket_service_1.SocketService !== "undefined" && web_socket_service_1.SocketService) === "function" ? _f : Object, typeof (_g = typeof common_1.Location !== "undefined" && common_1.Location) === "function" ? _g : Object, typeof (_h = typeof log_1.default !== "undefined" && log_1.default) === "function" ? _h : Object, typeof (_j = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _j : Object, typeof (_k = typeof vehicle_export_service_1.default !== "undefined" && vehicle_export_service_1.default) === "function" ? _k : Object, typeof (_l = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _l : Object, typeof (_m = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _m : Object])
], VehicleTable);
exports.VehicleTable = VehicleTable;
